/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines */
import {
  IAddProductImpression,
  ICollectionIdsFilterDTO,
  IGetCategoryProducts,
  IGetInitialData,
  IOldGetInitialData,
  IProduct,
  IProductOption,
  ProductEnrichmentResponse,
  ProductItemsState,
  ProductOptionsDisplayOption,
  ProductsManifest,
  ReducedOptionSelection,
} from '../types/galleryTypes';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {DataApi, GetProductsRequest, GetProductsResponse} from '../api/DataApi';
import {GetDataQuery} from '../graphql/queries-schema';
import {
  BATCH_MAX_SIZE,
  DEFAULT_COLLECTION_ID,
  FedopsInteraction,
  MAX_PRODUCTS_BATCHING,
  origin,
  TRACK_EVENT_COLLECTION,
  trackEventMetaData,
  TrackEvents,
  AddToCartFlowType,
  Experiments,
} from '../constants';
import {
  AddToCartActionOption,
  APP_DEFINITION_ID,
  BiButtonActionType,
  STORAGE_PAGINATION_KEY,
  STORES_APP_DEF_ID,
} from '@wix/wixstores-client-core';
import {
  INavigationProductDescriptor,
  IStoreFrontNavigationContext,
} from '@wix/wixstores-client-core/dist/es/src/types/site-map';
import {
  actualPrice,
  actualSku,
  hasSubscriptionPlans,
  isPreOrder,
} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import {ProductsOptionsService, ProductsVariantInfoMap} from './ProductsOptionsService';
import {QuickViewActions} from '@wix/wixstores-client-storefront-sdk/dist/es/src/actions/QuickViewActions/QuickViewActions';
import {IOptionSelectionVariant} from '@wix/wixstores-client-core/dist/es/src/types/product';
import {getProductVariantBySelectionIds} from '@wix/wixstores-client-core/dist/es/src/productVariantCalculator/ProductVariantCalculator';
import {ProductsPriceRangeService, ProductsPriceRangeServiceMap} from './ProductsPriceRangeService';
import _ from 'lodash';
import {IProductItem} from '@wix/wixstores-graphql-schema/dist/es/src/graphql-schema';
import {clickAddToCartWithOptionsSf, clickedOnProductQuickViewSf} from '@wix/bi-logger-ec-sf/v2';
import type {ControllerFlowAPI} from '@wix/yoshi-flow-editor';
import {ProductItemsService} from './ProductItemsService';
import {Filters} from '../types/filters';
import {mapISortingToIProductSortDto, mapISortingToSiteSearchSortDto} from './sort/iSortingToDtoMapper';
import {ISorting} from '../types/sorting';
import {IOnlineStoresViewerScript} from '@wix/wixstores-client-storefront-sdk';
import {isWarmUpDataEnabled, createWarmUpDataKey, WarmUpDataRequestType} from './warmUpDataUtils';
import {sortProductsByIDsList} from '../viewerScript/utils';

export class ProductsService {
  private readonly dataApi: DataApi;
  public products: IProduct[];
  private readonly productsOptionsService = new ProductsOptionsService();
  private readonly priceRangeService = new ProductsPriceRangeService();
  public totalCount: number;
  public collectionName: string;
  private filters: Filters = null;
  private collectionIds: ICollectionIdsFilterDTO;
  private sorting?: ISorting;
  public hideGallery = false;
  public allProductsCategoryId: string = DEFAULT_COLLECTION_ID;
  private readonly quickViewActions: QuickViewActions;
  private publicApiPromise: Promise<IOnlineStoresViewerScript['exports']>;
  private externalDataSourceGetProducts?: (req: GetProductsRequest) => Promise<GetProductsResponse>;
  private productsPerPage: number;
  private veloInputsProductIds: string[];
  private isCachedAlreadyUsed: boolean;

  constructor(
    private readonly siteStore: SiteStore,
    private readonly consumerName: string,
    private withOptions: boolean,
    private readonly withPriceRange: boolean,
    private readonly fedopsLogger,
    private readonly panoramaClient: ControllerFlowAPI['panoramaClient'],
    private readonly wixCodeApi: ControllerFlowAPI['controllerConfig']['wixCodeApi'],
    private readonly cacheKeySuffix: string,
    private readonly productItemsService: ProductItemsService
  ) {
    this.dataApi = new DataApi(this.siteStore);
    this.quickViewActions = new QuickViewActions(this.siteStore);
    this.loadOnlineStoresViewerScript();
  }

  private loadOnlineStoresViewerScript() {
    this.publicApiPromise = this.wixCodeApi.site.getPublicAPI(STORES_APP_DEF_ID);
  }

  public setExternalDataSourceGetProducts(val: (req: GetProductsRequest) => Promise<GetProductsResponse>) {
    this.externalDataSourceGetProducts = val;
    this.dataApi.setExternalDataSourceGetProducts(val);
  }

  public updateSort = (sorting: ISorting) => {
    this.sorting = sorting;
  };

  public updateFilters = (filters: Filters) => {
    this.filters = filters;
  };

  private setProducts(products: IProduct[]) {
    this.products = products;
    this.productsOptionsService.addProducts(this.products);
    this.priceRangeService.addProducts(this.products);
  }

  private setIsCachedAlreadyUsed(isCachedAlreadyUsed: boolean) {
    this.isCachedAlreadyUsed = isCachedAlreadyUsed;
  }

  public async enrichProductWithProductItems(productId: string): Promise<ProductEnrichmentResponse> {
    const data = await this.dataApi.getProductItemsByProductId(productId);
    const productItems = data?.data.catalog.product.productItems;
    const productIndex = this.products.findIndex((p) => p.id === productId);
    this.products[productIndex].productItems = productItems;

    this.productsOptionsService.addProducts(this.products);
    this.priceRangeService.addProducts(this.products);
    return {productItems, productIndex};
  }

  public async getProducts({
    filters,
    collectionIds,
    sorting,
    shouldSpecificCollectionQuery,
    limit,
  }: {
    filters: Filters;
    collectionIds: ICollectionIdsFilterDTO;
    sorting?: ISorting;
    shouldSpecificCollectionQuery?: boolean;
    limit?: number;
  }): Promise<IProduct[]> {
    if (!isWarmUpDataEnabled(this.siteStore)) {
      const request = {
        offset: 0,
        limit: limit || /* istanbul ignore next */ this.productsPerPage,
        collectionId: shouldSpecificCollectionQuery
          ? /* istanbul ignore next */ collectionIds.subCategory
          : collectionIds.mainCategory,
        withOptions: this.withOptions,
        withPriceRange: this.withPriceRange,
        sorting,
        filters:
          shouldSpecificCollectionQuery && /* istanbul ignore next */ !this.externalDataSourceGetProducts
            ? /* istanbul ignore next */ null
            : filters,
      };

      /* istanbul ignore next */
      const mergeGetProductsResponses = (responseA: GetProductsResponse, responseB: GetProductsResponse) => {
        responseA.list = responseA.list.concat(responseB.list);
        return responseA;
      };

      const response = await this.fetchQueryWithBatches<GetProductsRequest, GetProductsResponse>({
        request,
        fetchingFunction: (req: GetProductsRequest) => this.dataApi.getProductsByOffset(req),
        mergingFunction: mergeGetProductsResponses,
      });

      this.totalCount = response.totalCount;
      this.setProducts(response.list);
      this.filters = filters;
      this.collectionIds = collectionIds;
      this.sorting = sorting;
      this.sendTrackEvent(0);
      return this.products;
    }

    const key = createWarmUpDataKey(WarmUpDataRequestType.PRODUCTS, this.cacheKeySuffix);

    const cachedResponse = this.siteStore.windowApis.warmupData.get(key);
    if (cachedResponse && !this.isCachedAlreadyUsed) {
      this.totalCount = cachedResponse.totalCount;
      this.setProducts(cachedResponse.list);
      this.filters = filters;
      this.collectionIds = collectionIds;
      this.sorting = sorting;
      this.sendTrackEvent(0);
      this.setIsCachedAlreadyUsed(true);
      return this.products;
    }

    const request = {
      offset: 0,
      limit: limit || this.productsPerPage,
      collectionId: shouldSpecificCollectionQuery ? collectionIds.subCategory : collectionIds.mainCategory,
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
      sorting,
      filters: shouldSpecificCollectionQuery && !this.externalDataSourceGetProducts ? null : filters,
    };

    const mergeGetProductsResponses = (responseA: GetProductsResponse, responseB: GetProductsResponse) => {
      responseA.list = responseA.list.concat(responseB.list);
      return responseA;
    };

    const response = await this.fetchQueryWithBatches<GetProductsRequest, GetProductsResponse>({
      request,
      fetchingFunction: (req: GetProductsRequest) => this.dataApi.getProductsByOffset(req),
      mergingFunction: mergeGetProductsResponses,
    });

    this.totalCount = response.totalCount;
    this.setProducts(response.list);
    this.filters = filters;
    this.collectionIds = collectionIds;
    this.sorting = sorting;

    if (this.siteStore.isSSR()) {
      this.siteStore.windowApis.warmupData.set(key, response);
    }

    this.sendTrackEvent(0);
    return this.products;
  }

  private async lazyLoadProductItemsIfNeeded(productId: string, productsManifest: ProductsManifest) {
    try {
      if (productsManifest[productId].productItemsState === ProductItemsState.MISSING) {
        this.productItemsService.setProductItemsState(productsManifest, productId, ProductItemsState.LOADING);
        this.panoramaClient
          .transaction(FedopsInteraction.EnrichProductWithItems)
          .start({productId, componentType: this.consumerName});
        const {productItems, productIndex} = await this.enrichProductWithProductItems(productId);
        this.productItemsService.setProductItemsState(productsManifest, productId, ProductItemsState.AVAILABLE);
        this.panoramaClient.transaction(FedopsInteraction.EnrichProductWithItems).finish({
          productId,
          numberOfVariants: productItems.length,
          productPosition: productIndex,
          componentType: this.consumerName,
        });
      }
    } catch (err) {
      this.panoramaClient.errorMonitor().reportError(err);
    }
  }

  public async handleProductsOptionsChange({
    productId,
    selectionIds,
    productsManifest,
  }: {
    productId: string;
    selectionIds: number[];
    productsManifest?: ProductsManifest;
  }): Promise<void> {
    const product = this.products.find((p) => p.id === productId);
    await this.lazyLoadProductItemsIfNeeded(productId, productsManifest);
    this.productsOptionsService.handleUserInput(product.id, selectionIds);
    this.priceRangeService.handleUserInput(product.id, selectionIds);
  }

  public getProductAndVariantById(productId: string): {
    product: IProduct;
    variant: IProductItem;
  } {
    const product = this.products.find((p) => p.id === productId);
    const optionsSelectionsIds = this.productsOptionsService.getVariantSelectionIds(productId);
    const variant = getProductVariantBySelectionIds({
      product,
      variantSelectionIds: optionsSelectionsIds,
    });

    return {product, variant};
  }

  public async oldGetInitialData(options: Omit<IOldGetInitialData, 'withPriceRange'>): Promise<GetDataQuery> {
    if (!isWarmUpDataEnabled(this.siteStore)) {
      const {data} = await this.dataApi.oldGetInitialData({
        ...options,
        limit: this.productsPerPage,
        withPriceRange: this.withPriceRange,
        withOptions: this.withOptions,
      });
      return this.initState(data);
    }

    const key = createWarmUpDataKey(WarmUpDataRequestType.OLD_INITIAL_DATA, this.cacheKeySuffix);

    const cachedData = this.siteStore.windowApis.warmupData.get(key);
    if (cachedData) {
      return this.initState(cachedData);
    }

    const {data} = await this.dataApi.oldGetInitialData({
      ...options,
      limit: this.productsPerPage,
      withPriceRange: this.withPriceRange,
      withOptions: this.withOptions,
    });

    if (this.siteStore.isSSR()) {
      this.siteStore.windowApis.warmupData.set(key, data);
    }

    return this.initState(data);
  }

  private async fetchQueryWithBatches<R extends {limit?: number; offset?: number}, S>({
    request,
    fetchingFunction,
    mergingFunction,
  }: {
    request: R;
    fetchingFunction: (r: R) => Promise<S>;
    mergingFunction: (s1: S, s2: S) => S;
  }) {
    const {limit, offset} = request;

    const responsesPromises: Promise<S>[] = [];

    const totalProducts = limit - offset;
    const batches = Math.floor(totalProducts / BATCH_MAX_SIZE);
    let currentOffset = offset;

    for (let i = 0; i < batches; i++) {
      const batchOption = {
        ...request,
        limit: BATCH_MAX_SIZE,
        offset: currentOffset,
      };
      responsesPromises.push(fetchingFunction(batchOption));
      currentOffset += BATCH_MAX_SIZE;
    }

    const remainder = totalProducts % BATCH_MAX_SIZE;
    if (remainder) {
      const batchOption = {
        ...request,
        limit: remainder,
        offset: currentOffset,
      };
      responsesPromises.push(fetchingFunction(batchOption));
    }

    const response: S[] = await Promise.all(responsesPromises);

    return response.reduce(mergingFunction);
  }

  private async fetchInitialDataWithBatch(options: IGetInitialData) {
    const maxLimit = Math.min(options.limit, MAX_PRODUCTS_BATCHING);
    options.limit = maxLimit;

    const mergeGetInitialDataResponses = (responseA: {data: GetDataQuery}, responseB: {data: GetDataQuery}) => {
      /* istanbul ignore next: hypothetical case - TBD check with experiment whether can be deleted */
      if (responseB.data.catalog.category === null) {
        return responseA;
      }

      responseA.data.catalog.category.productsWithMetaData.list =
        responseA.data.catalog.category.productsWithMetaData.list.concat(
          responseB.data.catalog.category.productsWithMetaData.list
        );

      return responseA;
    };

    return this.fetchQueryWithBatches<
      IGetInitialData,
      {
        data: GetDataQuery;
      }
    >({
      request: options,
      fetchingFunction: (request: IGetInitialData) => this.dataApi.getInitialData(request),
      mergingFunction: mergeGetInitialDataResponses,
    });
  }

  public async getInitialData(options: Omit<IGetInitialData, 'withOptions' | 'withPriceRange'>): Promise<GetDataQuery> {
    return this.externalDataSourceGetProducts
      ? this.getInitialDataFromExternalSource(options)
      : this.getInitialDataFromCatalog(options);
  }

  private async getInitialDataFromExternalSource(options: Omit<IGetInitialData, 'withOptions' | 'withPriceRange'>) {
    const [externalDataResult, {data}] = await Promise.all([
      this.externalDataSourceGetProducts({
        ...options,
        collectionId: DEFAULT_COLLECTION_ID,
        offset: options?.offset,
        sorting: mapISortingToSiteSearchSortDto(this.sorting),
        limit: options.limit,
        withOptions: this.withOptions,
        withPriceRange: this.withPriceRange,
      }),
      this.dataApi.getInitialDataForExternalSource(options.externalId),
    ]);
    const initStateData: GetDataQuery = {
      ...data,
      catalog: {
        isCatalogV3: data.catalog.isCatalogV3,
        allProductsCategoryId: data.catalog.allProductsCategoryId,
        category: {
          id: data.catalog.allProductsCategoryId,
          name: '',
          visible: true,
          productsWithMetaData: {
            totalCount: externalDataResult.totalCount,
            list: externalDataResult.list,
          },
        },
      },
    };
    return this.initState(initStateData);
  }

  private async getInitialDataFromCatalog(options: Omit<IGetInitialData, 'withOptions' | 'withPriceRange'>) {
    let limit;
    if (options.limit) {
      limit = options.limit;
    } else {
      limit = this.productsPerPage;
    }

    const optionsWithOverrides: IGetInitialData = {
      ...options,
      limit,
      sort: mapISortingToIProductSortDto(this.sorting),
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
    };

    if (!isWarmUpDataEnabled(this.siteStore)) {
      const data = (await this.fetchInitialDataWithBatch(optionsWithOverrides)).data;
      return this.initState(data);
    }

    const key = createWarmUpDataKey(WarmUpDataRequestType.INITIAL_DATA, this.cacheKeySuffix);

    const cachedData = this.siteStore.windowApis.warmupData.get(key);
    if (cachedData) {
      return this.initState(cachedData);
    }

    const data = (await this.fetchInitialDataWithBatch(optionsWithOverrides)).data;

    if (this.siteStore.isSSR()) {
      this.siteStore.windowApis.warmupData.set(key, data);
    }

    return this.initState(data);
  }

  public async getRelatedProductsByAlgorithm(options: {
    externalId: string;
    productIds: string[];
    algorithmId: string;
    appId: string;
  }) {
    const {data} = await this.dataApi.getRelatedProductsByAlgorithm({
      ...options,
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
    });
    const parsedData: Pick<GetDataQuery, 'catalog' | 'appSettings'> = {
      catalog: {
        isCatalogV3: data.catalog.isCatalogV3,
        category: {
          productsWithMetaData: {
            list: data.catalog.relatedProducts,
            totalCount: data.catalog.relatedProducts.length,
          },
          name: '',
          id: '',
          visible: true,
        },
        allProductsCategoryId: null,
      },
      appSettings: data.appSettings,
    };
    this.initState(parsedData);
    return parsedData;
  }

  private initState(data: GetDataQuery): GetDataQuery {
    if (data.catalog.category === null) {
      // slider gallery
      data.catalog.category = {productsWithMetaData: {list: [], totalCount: 0}, id: '', name: '', visible: true};
      this.hideGallery = true;
    }

    const productsToSet =
      this.veloInputsProductIds?.length > 0
        ? sortProductsByIDsList(data.catalog.category.productsWithMetaData.list, this.veloInputsProductIds)
        : data.catalog.category.productsWithMetaData.list;

    this.setProducts(productsToSet);

    this.setMainCollection(data.catalog.category.id);
    this.collectionName = data.catalog.category.name;
    this.totalCount = data.catalog.category.productsWithMetaData.totalCount;
    if (data.catalog.allProductsCategoryId) {
      this.allProductsCategoryId = data.catalog.allProductsCategoryId;
    }
    this.sendTrackEvent(0);
    return data;
  }

  public sendTrackEvent(fromIndex: number): void {
    if (this.siteStore.isSSR()) {
      return;
    }

    const items: IAddProductImpression[] = this.products.slice(fromIndex).map((p, i) => ({
      id: p.id,
      name: p.name,
      list: this.consumerName,
      category: TRACK_EVENT_COLLECTION,
      position: i + fromIndex,
      price: p.comparePrice || p.price,
      currency: this.siteStore.currency,
      dimension3: p.isInStock ? 'in stock' : 'out of stock',
    }));

    this.siteStore.windowApis.trackEvent('AddProductImpression', {
      appDefId: APP_DEFINITION_ID,
      contents: items,
      origin: 'Stores',
    });
  }

  public hasMoreProductsToLoad(): boolean {
    return this.products.length < this.totalCount;
  }

  public setProductsPerPage(productsPerPage: number): void {
    this.productsPerPage = productsPerPage;
  }

  public getProductPerPage(): number {
    return this.productsPerPage;
  }

  public setWithOptions(withOptions: boolean): void {
    this.withOptions = withOptions;
  }

  public getProduct(id: string): IProduct {
    return this.products.find((p) => p.id === id);
  }

  public async getCategoryProducts({compId, limit, offset}: IGetCategoryProducts): Promise<void> {
    const {data} = await this.dataApi.getCategoryProducts({
      compId,
      limit,
      offset,
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
    });
    const retrievedProducts = data.catalog.category.productsWithMetaData.list;
    this.products.splice(offset, retrievedProducts.length, ...retrievedProducts);
    this.setProducts(this.products);
  }

  public async loadMoreProducts({
    visibleProducts,
    shouldSpecificCollectionQuery,
  }: {
    visibleProducts: number;
    shouldSpecificCollectionQuery?: boolean;
  }): Promise<IProduct[]> {
    const apiResponse = await this.dataApi.getProducts({
      fromIndex: visibleProducts,
      toIndex: visibleProducts + this.productsPerPage,
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
      sorting: this.sorting,
      filters: shouldSpecificCollectionQuery ? null : this.filters,
      collectionId: shouldSpecificCollectionQuery ? this.collectionIds.subCategory : this.collectionIds.mainCategory,
    });
    if (apiResponse.list.length === 0) {
      return null;
    }
    this.setProducts(this.products.concat([...apiResponse.list]));
    this.sendTrackEvent(visibleProducts);
    return this.products;
  }

  public async loadProducts({
    from,
    to,
    shouldSpecificCollectionQuery,
  }: {
    from: number;
    to: number;
    shouldSpecificCollectionQuery?: boolean;
  }): Promise<IProduct[]> {
    const apiResponse = await this.dataApi.getProducts({
      fromIndex: from,
      toIndex: to,
      withOptions: this.withOptions,
      withPriceRange: this.withPriceRange,
      sorting: this.sorting,
      filters: shouldSpecificCollectionQuery ? null : this.filters,
      collectionId: shouldSpecificCollectionQuery ? this.collectionIds.subCategory : this.collectionIds.mainCategory,
    });
    this.setProducts([...apiResponse.list]);
    this.totalCount = apiResponse.totalCount;
    return this.products;
  }

  public async sortProducts(sorting: ISorting, shouldSpecificCollectionQuery: boolean): Promise<IProduct[]> {
    await this.getProducts({
      filters: this.filters,
      collectionIds: this.collectionIds,
      sorting,
      shouldSpecificCollectionQuery,
    });
    return this.products;
  }

  public async filterProducts({
    filters,
    collectionIds,
    shouldSpecificCollectionQuery,
    limit,
  }: {
    filters: Filters;
    collectionIds: ICollectionIdsFilterDTO;
    shouldSpecificCollectionQuery: boolean;
    limit?: number;
  }): Promise<IProduct[]> {
    this.setProducts(
      await this.getProducts({
        filters,
        collectionIds,
        sorting: this.sorting,
        shouldSpecificCollectionQuery,
        limit,
      })
    );
    return this.products;
  }

  public getMainCollectionId(): string {
    return this.collectionIds.mainCategory;
  }

  public storeNavigation(pageId: string): void {
    const paginationMap = this.products
      .filter((p) => (p as any).isFake !== true)
      .map((p) => ({slug: p.urlPart, id: p.id})) as INavigationProductDescriptor[];

    const history: IStoreFrontNavigationContext = {
      pageId,
      paginationMap,
      pagePath: this.siteStore.location.path,
    };

    this.siteStore.storage.local.setItem(STORAGE_PAGINATION_KEY, JSON.stringify(history));
  }

  public quickViewProduct(
    productId: string,
    index: number,
    params: {
      galleryProductsLogic?: string;
      galleryType?: string;
      compId?: string;
      externalId?: string;
      selectionIds?: number[];
      quantity?: number;
      galleryInputId?: string;
      impressionId?: string;
    }
  ): Promise<any> {
    const product = this.getProduct(productId);
    this.siteStore.webBiLogger.report(
      clickedOnProductQuickViewSf({
        productId,
        hasRibbon: !!product.ribbon,
        hasOptions: this.hasOptions(product),
        index,
        galleryProductsLogic: params.galleryProductsLogic,
        galleryType: params.galleryType,
        rank: index,
        galleryInputId: params.galleryInputId,
        impressionId: params.impressionId,
      })
    );
    this.sendClickTrackEvent(product, index);
    return this.quickViewActions.quickViewProduct({
      origin: this.consumerName.split(' ').join('-'),
      urlPart: product.urlPart,
      compId: params.compId,
      externalId: params.externalId,
      selectionIds: params.selectionIds,
      quantity: params.quantity,
      title: product.name,
    });
  }

  public sendClickTrackEvent(product: IProduct, index: number): void {
    this.siteStore.windowApis.trackEvent('ClickProduct', {
      appDefId: APP_DEFINITION_ID,
      id: product.id,
      origin: 'Stores',
      name: product.name,
      list: 'Grid Gallery',
      category: TRACK_EVENT_COLLECTION,
      position: index,
      price: product.comparePrice || product.price,
      currency: this.siteStore.currency,
      type: product.productType,
      sku: product.sku,
    });
  }

  private readonly hasOptions = (product: IProduct) => !!product.options.length;

  private readonly hasSubscriptionPlans = (product: IProduct) => {
    return hasSubscriptionPlans(product);
  };

  private readonly flatAndEnrichSelections = (productOptions: IProductOption[]): ReducedOptionSelection[] =>
    _.flatten(
      productOptions.map(({selections, key: optionKey, id: optionId}) =>
        selections.map<ReducedOptionSelection>(({key: selectionKey, id: selectionId}) => ({
          selectionKey,
          selectionId,
          optionId,
          optionKey,
        }))
      )
    );
  private readonly calculateVariantOptions = (selectionIds: number[], product: IProduct): Record<string, string> => {
    const selectionSet = selectionIds.reduce((set, id) => set.add(id), new Set());
    return this.flatAndEnrichSelections(product.options)
      .filter((enrichedSelection) => selectionSet.has(enrichedSelection.selectionId))
      .reduce((acc, enrichedSelection) => {
        acc[enrichedSelection.optionKey] = enrichedSelection.selectionKey;
        return acc;
      }, {});
  };

  private getAddToCartActionBi(addToCartAction: AddToCartActionOption, hasNoMiniCart: boolean) {
    if (!hasNoMiniCart && addToCartAction === AddToCartActionOption.TINY_CART) {
      return 'tiny-cart';
    } else if (!hasNoMiniCart && addToCartAction === AddToCartActionOption.MINI_CART) {
      return 'mini-cart';
    } else if (
      addToCartAction === AddToCartActionOption.CART ||
      (hasNoMiniCart && addToCartAction !== AddToCartActionOption.NONE)
    ) {
      return 'cart';
    } else {
      return 'none';
    }
  }

  private supportsDirectAddToCartFromGallery({
    product,
    isProductOptionsEnabled,
    isShowOnlyColorOptionsEnabled,
    productOptionsDisplayOption,
  }: {
    product: IProduct;
    isProductOptionsEnabled: boolean;
    isShowOnlyColorOptionsEnabled: boolean;
    productOptionsDisplayOption: ProductOptionsDisplayOption;
  }): boolean {
    const numberOfOptions = product.options?.length || 0;
    if (numberOfOptions === 0) {
      return true;
    }

    const isShowFirstProductOptionInGalleryExperimentEnabled = this.siteStore.experiments.enabled(
      Experiments.ShouldShowFirstProductOptionInGallery
    );

    const hasLessThanThreeOptions = numberOfOptions < 3;
    const numberOfColorOptions = this.productsOptionsService.getNumberOfColorOptions(product);
    const hasLessThanTwoColorOptions = numberOfColorOptions < 2;
    const hasNonColorOption = numberOfColorOptions !== numberOfOptions;
    const hasNonColorOptionsAndColorOptionsOnlyEnabled = !isShowFirstProductOptionInGalleryExperimentEnabled
      ? isShowOnlyColorOptionsEnabled && hasNonColorOption
      : productOptionsDisplayOption === ProductOptionsDisplayOption.FIRST_COLOR && hasNonColorOption;

    const isFirstOptionAnyTypeDisplayed =
      isShowFirstProductOptionInGalleryExperimentEnabled &&
      productOptionsDisplayOption === ProductOptionsDisplayOption.FIRST_ANY_OPTION
        ? numberOfOptions === 1
        : true;

    return (
      isProductOptionsEnabled &&
      hasLessThanThreeOptions &&
      hasLessThanTwoColorOptions &&
      !hasNonColorOptionsAndColorOptionsOnlyEnabled &&
      isFirstOptionAnyTypeDisplayed
    );
  }

  private async executeAddToCart({
    productId,
    quantity,
    addToCartAction,
    impressionId,
    galleryProductsLogic,
    rank,
    galleryInputId,
  }: {
    productId: string;
    quantity: number;
    addToCartAction: AddToCartActionOption;
    impressionId?: string;
    galleryProductsLogic?: string;
    rank?: number;
    galleryInputId?: string;
  }): Promise<any> {
    const product = this.getProduct(productId);
    const optionsSelectionsIds = this.productsOptionsService.getVariantSelectionIds(productId);
    const optionsSelectionsByNames = this.calculateVariantOptions(optionsSelectionsIds, product);
    const hasNoMiniCart = !this.siteStore.isMiniCartExists;
    const variant = getProductVariantBySelectionIds({
      product,
      variantSelectionIds: optionsSelectionsIds,
    });

    const trackParams = this.getTrackEventParams(product);
    this.siteStore.windowApis.trackEvent(TrackEvents.ViewContent, trackParams);
    this.fedopsLogger.interactionStarted(FedopsInteraction.AddToCart);
    this.panoramaClient.transaction(FedopsInteraction.AddToCart).start();

    const isPreOrderState = isPreOrder(product, variant);
    const variantId = variant?.id;

    const trackData = {
      ...trackParams,
      buttonType: isPreOrderState ? BiButtonActionType.PreOrder : BiButtonActionType.AddToCart,
      appName: 'galleryApp',
      productType: product.productType as any,
      isNavigateCart: hasNoMiniCart,
      navigationClick: this.getAddToCartActionBi(addToCartAction, hasNoMiniCart),
      impressionId,
      galleryProductsLogic,
      rank,
      galleryInputId,
    };

    const onSuccess = () => {
      this.fedopsLogger.interactionEnded(FedopsInteraction.AddToCart);
      this.panoramaClient.transaction(FedopsInteraction.AddToCart).finish();
    };

    const publicApi: IOnlineStoresViewerScript['exports'] = await this.publicApiPromise;

    await publicApi.cart.addToCart(
      productId,
      quantity,
      {
        choices: optionsSelectionsByNames,
        optionsSelectionsIds,
        addToCartAction,
        variantId,
      },
      isPreOrderState,
      trackData
    );

    onSuccess();
  }

  private async handleDirectAddToCart({
    product,
    productId,
    quantity,
    addToCartAction,
    impressionId,
    galleryProductsLogic,
    rank,
    galleryInputId,
  }: {
    product: IProduct;
    productId: string;
    quantity: number;
    addToCartAction: AddToCartActionOption;
    impressionId?: string;
    galleryProductsLogic?: string;
    rank?: number;
    galleryInputId?: string;
  }): Promise<{requiresAdditionalSelection?: boolean}> {
    if (!this.productsOptionsService.canAddToCart(product)) {
      return {requiresAdditionalSelection: true};
    }

    return this.executeAddToCart({
      productId,
      quantity,
      addToCartAction,
      impressionId,
      galleryProductsLogic,
      rank,
      galleryInputId,
    });
  }

  private openQuickView({
    product,
    index,
    impressionId,
    galleryProductsLogic,
    rank,
    galleryInputId,
    compId,
    externalId,
    optionsSelectionsIds,
    quantity,
  }: {
    product: IProduct;
    index: number;
    impressionId: string;
    galleryProductsLogic: string;
    rank: number;
    galleryInputId: string;
    compId: string;
    externalId: string;
    optionsSelectionsIds: number[];
    quantity: number;
  }) {
    this.siteStore.webBiLogger.report(
      clickAddToCartWithOptionsSf({
        appName: 'galleryApp',
        origin,
        hasOptions: true,
        productId: product.id,
        productType: product.productType,
        navigationClick: this.siteStore.isMobile() ? 'product-page' : 'quick-view',
        impressionId,
        galleryProductsLogic,
        rank,
        galleryInputId,
      })
    );
    return this.quickViewProduct(product.id, index, {
      compId,
      externalId,
      selectionIds: optionsSelectionsIds,
      quantity,
    });
  }

  private determineAddToCartFlowType({
    product,
    isProductOptionsEnabled,
    isShowOnlyColorOptionsEnabled,
    isQuickBuyViewerExperimentEnabled,
    isAddToCartFlowTypeIsQuickAdd,
    productOptionsDisplayOption,
  }: {
    product: IProduct;
    isProductOptionsEnabled: boolean;
    isShowOnlyColorOptionsEnabled: boolean;
    isQuickBuyViewerExperimentEnabled: boolean;
    isAddToCartFlowTypeIsQuickAdd: boolean;
    productOptionsDisplayOption: ProductOptionsDisplayOption;
  }): AddToCartFlowType {
    const hasBlockingFeatures =
      this.hasSubscriptionPlans(product) || this.productsOptionsService.hasCustomTextFields(product);
    const supportsDirectAddToCartFromGallery = this.supportsDirectAddToCartFromGallery({
      product,
      isProductOptionsEnabled,
      isShowOnlyColorOptionsEnabled,
      productOptionsDisplayOption,
    });

    if (hasBlockingFeatures) {
      return AddToCartFlowType.QUICK_VIEW;
    }

    if (!supportsDirectAddToCartFromGallery) {
      const canUseQuickAdd = isQuickBuyViewerExperimentEnabled && isAddToCartFlowTypeIsQuickAdd;
      return canUseQuickAdd ? AddToCartFlowType.QUICK_ADD : AddToCartFlowType.QUICK_VIEW;
    }

    return AddToCartFlowType.DIRECT_ADD;
  }

  public async addToCartFlow({
    productsManifest,
    addToCartAction,
    productId,
    index,
    quantity,
    compId,
    externalId,
    impressionId,
    galleryProductsLogic,
    rank,
    galleryInputId,
    isProductOptionsEnabled,
    isShowOnlyColorOptionsEnabled,
    isQuickBuyViewerExperimentEnabled,
    isAddToCartFlowTypeIsQuickAdd,
    productOptionsDisplayOption,
  }: {
    productsManifest: ProductsManifest;
    addToCartAction: AddToCartActionOption;
    productId: string;
    index: number;
    quantity: number;
    compId: string;
    externalId: string;
    impressionId?: string;
    galleryProductsLogic?: string;
    rank?: number;
    galleryInputId?: string;
    isProductOptionsEnabled: boolean;
    isShowOnlyColorOptionsEnabled: boolean;
    isQuickBuyViewerExperimentEnabled: boolean;
    isAddToCartFlowTypeIsQuickAdd: boolean;
    productOptionsDisplayOption: ProductOptionsDisplayOption;
  }): Promise<{requiresAdditionalSelection?: boolean}> {
    const product = this.getProduct(productId);
    const addToCartFlowType = this.determineAddToCartFlowType({
      product,
      isProductOptionsEnabled,
      isShowOnlyColorOptionsEnabled,
      isQuickBuyViewerExperimentEnabled,
      isAddToCartFlowTypeIsQuickAdd,
      productOptionsDisplayOption,
    });
    const optionsSelectionsIds = this.productsOptionsService.getVariantSelectionIds(productId);

    switch (addToCartFlowType) {
      case AddToCartFlowType.QUICK_VIEW:
        return this.openQuickView({
          product,
          index,
          impressionId,
          galleryProductsLogic,
          rank,
          galleryInputId,
          compId,
          externalId,
          optionsSelectionsIds,
          quantity,
        });
      case AddToCartFlowType.QUICK_ADD:
        this.productItemsService.setProductItemsState(productsManifest, productId, ProductItemsState.QUICK_ADD);
        return;
      case AddToCartFlowType.DIRECT_ADD:
        return this.handleDirectAddToCart({
          product,
          productId,
          quantity,
          addToCartAction,
          impressionId,
          galleryProductsLogic,
          rank,
          galleryInputId,
        });
    }
  }

  public async oldAddToCart({
    productId,
    index,
    quantity,
    compId,
    externalId,
    addToCartAction,
    impressionId,
    galleryProductsLogic,
    rank,
    galleryInputId,
  }: {
    productId: string;
    index: number;
    quantity: number;
    compId: string;
    externalId: string;
    addToCartAction: AddToCartActionOption;
    impressionId?: string;
    galleryProductsLogic?: string;
    rank?: number;
    galleryInputId?: string;
  }): Promise<any> {
    const product = this.getProduct(productId);
    const trackParams = this.getTrackEventParams(product);
    const optionsSelectionsIds = this.productsOptionsService.getVariantSelectionIds(productId);
    const shouldOpenQuickView =
      !this.productsOptionsService.canAddToCart(product) || this.hasSubscriptionPlans(product);

    if (shouldOpenQuickView) {
      this.siteStore.webBiLogger.report(
        clickAddToCartWithOptionsSf({
          appName: 'galleryApp',
          origin,
          hasOptions: true,
          productId,
          productType: product.productType,
          navigationClick: this.siteStore.isMobile() ? /* istanbul ignore next */ 'product-page' : 'quick-view',
          impressionId,
          galleryProductsLogic,
          rank,
          galleryInputId,
        })
      );
      return this.quickViewProduct(productId, index, {
        compId,
        externalId,
        selectionIds: optionsSelectionsIds,
        quantity,
      });
    }

    const optionsSelectionsByNames = this.calculateVariantOptions(optionsSelectionsIds, product);
    const hasNoMiniCart = !this.siteStore.isMiniCartExists;
    const variant = getProductVariantBySelectionIds({
      product,
      variantSelectionIds: optionsSelectionsIds,
    });

    this.siteStore.windowApis.trackEvent(TrackEvents.ViewContent, trackParams);
    this.fedopsLogger.interactionStarted(FedopsInteraction.AddToCart);
    this.panoramaClient.transaction(FedopsInteraction.AddToCart).start();

    const isPreOrderState = isPreOrder(product, variant);
    const variantId = variant?.id;

    const trackData = {
      ...trackParams,
      buttonType: isPreOrderState
        ? /* istanbul ignore next */ BiButtonActionType.PreOrder
        : BiButtonActionType.AddToCart,
      appName: 'galleryApp',
      productType: product.productType as any,
      isNavigateCart: hasNoMiniCart,
      navigationClick: this.getAddToCartActionBi(addToCartAction, hasNoMiniCart),
      impressionId,
      galleryProductsLogic,
      rank,
      galleryInputId,
    };

    const onSuccess = () => {
      this.fedopsLogger.interactionEnded(FedopsInteraction.AddToCart);
      this.panoramaClient.transaction(FedopsInteraction.AddToCart).finish();
    };

    /* istanbul ignore next */
    const publicApi: IOnlineStoresViewerScript['exports'] = await this.publicApiPromise;

    await publicApi.cart.addToCart(
      productId,
      quantity,
      {
        choices: optionsSelectionsByNames,
        optionsSelectionsIds,
        addToCartAction,
        variantId,
      },
      isPreOrderState,
      trackData
    );

    onSuccess();
  }

  private getTrackEventParams(product: IProduct) {
    const variantSelectionIds = this.productsOptionsService.getVariantSelectionIds(product.id);
    const variant = getProductVariantBySelectionIds({product, variantSelectionIds}) as IOptionSelectionVariant;
    return {
      ...trackEventMetaData,
      id: product.id,
      name: product.name,
      price: actualPrice(product, variant),
      currency: this.siteStore.currency,
      sku: actualSku(product, variant),
      type: product.productType,
    };
  }

  public clearSelections() {
    this.productsOptionsService.clearSelections();
    this.priceRangeService.clearSelections();
  }

  public getVariantInfoMap(): ProductsVariantInfoMap {
    return this.productsOptionsService.getVariantInfoMap();
  }

  public get productPriceRangeMap(): ProductsPriceRangeServiceMap {
    return this.withPriceRange ? this.priceRangeService.getProductPriceRangeMap() : {};
  }

  public async getCategoryInitialData(externalId: string, currentCategoryId: string) {
    if (!isWarmUpDataEnabled(this.siteStore)) {
      const data = await this.dataApi.getCategoryInitialData({externalId, currentCategoryId});
      this.allProductsCategoryId =
        data?.data?.catalog?.allProductsCategoryId || /* istanbul ignore next */ DEFAULT_COLLECTION_ID;
      return data;
    }

    const key = createWarmUpDataKey(WarmUpDataRequestType.CATEGORY_INITIAL_DATA, this.cacheKeySuffix);

    const cachedData = this.siteStore.windowApis.warmupData.get(key);
    if (cachedData) {
      this.allProductsCategoryId = cachedData?.catalog?.allProductsCategoryId || DEFAULT_COLLECTION_ID;
      return {data: cachedData};
    }

    const data = await this.dataApi.getCategoryInitialData({externalId, currentCategoryId});
    this.allProductsCategoryId = data?.data?.catalog?.allProductsCategoryId || DEFAULT_COLLECTION_ID;

    if (this.siteStore.isSSR()) {
      this.siteStore.windowApis.warmupData.set(key, data.data);
    }

    return data;
  }

  public setMainCollection = (collectionId: string) => {
    this.collectionIds = {mainCategory: collectionId};
  };

  public setVeloInputsProductIds = (productIds: string[]) => {
    this.veloInputsProductIds = productIds;
  };
}
